//
import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { HelperService, AppSettings, AuthenticationService, Getunitdetails, Agents } from '../../../../services/_services';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { Router, Route, ActivatedRoute } from "@angular/router";
import { Base64Pipe } from '../../../../services/pipes/base64/base64.pipe';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import Swal from 'sweetalert2';

declare var document,$;

  @Component({
    selector: 'app-order-in-progress',
    templateUrl: './order-in-progress.component.html',
    styleUrls: ['./order-in-progress.component.css']
  })
  export class OrderInProgressComponent implements OnInit {
    public despositionArray   : any = AppSettings.disposition;
    public documentTypeArray  : any = AppSettings.documentType;
    public orderStatus        : any = AppSettings.orderStatus;

    public selected_PR_Action : any = null;
    public PR_Index           : any = null;
    public PR_ActionLoader    : any = false;
    public PR_FileLoader      : any = false;
    public browserSub         : any;
    public activeUser         : any;
    public loading            : any = false;
    public paginatePage       : any;
    public leads              : any = [];
    public leads_copy         : any = [];
    public lead_Index         : any = null;
    public comments           : any = [];
    public agentsSub          : any;
    public all_users          : any;
    public agents             : any;
    public loader             : any;

    @ViewChild(DataTableDirective)
    public dtElement               : DataTableDirective;
    public dtOptions               : DataTables.Settings = {};
    public dtTrigger               : any = new Subject();

    public searchParams            : any = { orderStatus: null, writer_id: null, order_id: '', date_from: '', date_to:'' };
    public fullRangeDate           : any;
    public selectedDesposition     : any;
    public routeSaver              : any;
    public writers                 : any;
    public notes                   : any;
    public addNoteId               : any;
    public addNoteIndex            : any;
    public addingNote              : any = false;
    public base64Pipe              : any = new Base64Pipe;

    constructor(
      private authenticationService : AuthenticationService,
      private helperService       : HelperService,
      private activatedRoute      : ActivatedRoute,
      private router              : Router,
      private agentsService       : Agents,
      private cdr                 : ChangeDetectorRef,
    ) {

      this.browserSub = this.authenticationService.isBrowser.subscribe(isBrowser => {
        if (isBrowser) {
          // Get Agents
          this.agentsSub = this.agentsService.agentsS$.subscribe(agents => {
            if (agents) {
              this.all_users = agents.all_users;
              this.agents    = agents.agents;
              this.writers   = agents.writers;
            }
          });

          this.activeUser = this.authenticationService.get_currentUserValue();

          this.routeSaver = this.router.url;

          let dataLang        = $.extend(true, {},  AppSettings.dataTableLang);

          this.dtOptions = {
            paging: true,
            info: true,
            // ordering: false,
            pagingType : 'full_numbers',
            pageLength : 500,
            serverSide : true,
            processing : true,
            searching  : false,
            language   : dataLang,
            "columnDefs": [
              { "orderable": false,     "targets": 0  },
              { "orderable": false,     "targets": 1  },
              { "orderable": false,     "targets": 2  },
              { "orderable": false,     "targets": 3  },
              { "orderable": false,     "targets": 4  },
              { "orderable": true,      "targets": 5  },
              { "orderable": false,     "targets": 6  },
              { "orderable": true,      "targets": 7  },
              { "orderable": false,     "targets": 8  },
              { "orderable": false,     "targets": 9  },
              { "orderable": false,     "targets": 10 },
              { "orderable": false,     "targets": 11 },
              { "orderable": false,     "targets": 12 },
            ],
            "order": [[ 5, "asc" ]],
            ajax: (dataTablesParameters: any, callback) => {
              // Show Loader
              this.loading = true;

              let url = AppSettings.API_ENDPOINT + 'support/inprogress-orders';;

              let dtParams = {
                              order_id          : this.searchParams.order_id,
                              status            : this.searchParams.orderStatus,
                              writer_id         : this.searchParams.writer_id,
                              date_from         : this.searchParams.date_from ? this.helperService.caonvertDateToString(this.searchParams.date_from) : '',
                              date_to           : this.searchParams.date_to   ? this.helperService.caonvertDateToString(this.searchParams.date_to, false)   : '',
                              start             : dataTablesParameters.start,
                              length            : dataTablesParameters.length,
                              order             : dataTablesParameters.order,
                              columns           : dataTablesParameters.columns
                            };

              // For Record Serial Numbers
              this.paginatePage = dataTablesParameters.start;
              this.leads.data = [];
              this.helperService.httpPostRequestsDecryp(url, dtParams)
                .then( resp => {
                    this.leads      = JSON.parse(resp);
                    this.leads_copy = $.extend(true, {},  this.leads);

                    console.log("this.leads: ", this.leads);


                    // Set Default page len
                    this.dtOptions.pageLength = this.dtElement['dt'].page.len();

                    // Hide Loader
                    this.loading = false;

                    callback({
                      recordsTotal: this.leads.total,
                      recordsFiltered: this.leads.total,
                      // recordsFiltered: resp['recordsFiltered'],
                      // recordsFiltered: 1000,
                      data: []
                    });

                    // // $(".paginate_button .current").css("color", "white");
                    // // console.log('$(".paginate_button .current"): ',$(".paginate_button .current"))
                    $('div.dataTables_length select').addClass('dt-form-control');
                    $('div.dataTables_filter input').addClass('dt-form-control');
                })
                .catch(error => {
                    // Set loader false
                    this.loading = false;

                    // // Rerender DT in case of failure
                    // this.rerender();

                    console.log("error: ",error);
                });
            },
            columns: [
              // { data: 'multiDelete' },
              { data: 'id' },
              { data: 'id' },
              { data: 'date' },
              { data: 'name' },
              { data: 'amount' },
              { data: 'delivery_date' },
              { data: 'writer_name' },
              { data: 'writer_delivery_date' },
              { data: 'assigned_by' },
              { data: 'verified' },
              { data: 'status' },
              { data: 'selfNotes' },
              { data: 'action' },
            ],
            // Use this attribute to enable the responsive extension
            responsive: false
          }
        }
	    });
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
      this.dtTrigger.next();
    }

    ngOnDestroy(): void {
      // Do not forget to unsubscribe the event
      this.dtTrigger.unsubscribe();

      if (typeof this.agentsSub != 'undefined') {
        //prevent memory leak when component destroyed
        this.agentsSub.unsubscribe();
        this.browserSub.unsubscribe();
      }
    }

    rerender(): void {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

        // Destroy the table first
        dtInstance.destroy();

        // Call the dtTrigger to rerender again
        this.dtTrigger.next();
      });
    }

    clearFilters(){
      this.searchParams = { orderStatus: null, writer_id: null, order_id: '', date_from: '', date_to:'' };
        this.fullRangeDate ='';

      this.rerender();
    }

    splitFromTo() {
      if(this.fullRangeDate){
        this.searchParams.date_from = this.fullRangeDate[0];
        this.searchParams.date_to =   this.fullRangeDate[1];
      }

      this.rerender();
    }

    setDeadlineTimer(time){
      if(typeof $ != "undefined"){
        // Set the date we're counting down to
        var countDownDate = new Date(time).getTime();

        // Get today's date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if(days > 0){
          return days + 'd : ' + hours + 'hr : ' +  + minutes + 'Min' ;
        }
        else if(days == 0){
          return hours + 'hr : ' +  + minutes + 'Min' ;
        }
        else {
          return days + 'd : ' + hours + 'hr : ' +  + minutes + 'Min' ;
          // return "-";
        }
      }
    }

    showNotes(lead,index) {
      // Show Loader
      this.leads.data[index].loadingNotes = true;

      // Reset Notes
      this.notes = '';

      this.addNoteId    = lead.id;
      this.addNoteIndex = index;

      let url = AppSettings.API_ENDPOINT + "shared/get-comments";
      let data = { o: lead.id, type : 'Order-In-Progress'};
      this.helperService.httpPostRequests(url,data).then(resp => {
          if(typeof resp != "undefined") {
            this.comments = resp;
            $("#notesModal").modal("show");
          }

          // Hide Loader
          this.leads.data[index].loadingNotes = false;
      }).catch(err => {
          // Hide Loader
          this.leads.data[index].loadingNotes = false;
      });
    }

    addNotes() {
      // Show Loader
      this.addingNote = true;

      let url = AppSettings.API_ENDPOINT + "shared/insert-note";
      let data = { id: this.addNoteId, note : this.notes,type : 'Order-In-Progress'};

      this.helperService.httpPostRequests(url,data).then(resp => {
          if(typeof resp != "undefined") {
              this.notes = "";
              $("#notesModal").modal("hide");
              this.leads.data[this.addNoteIndex].view_notes = true;
              Swal.fire('', resp.message , 'success');
          }

          // Hide Loader
          this.addingNote = false;
      }).catch(err => {
          // Hide Loader
          this.addingNote = false;
      });
    }



    agentSearch(id, agentArr) {
      for (var i = 0; i < agentArr.length; i++) {
        if (agentArr[i].id === id) {
          return agentArr[i].name;
        }
      }

      return null;
    }
  }
